import { TmBaseComponent } from '@treasury/presentation';
import { chevronForwardIcon } from '@treasury/presentation/assets/icons';
import '@treasury/presentation/components/tm-badge';
import '@treasury/presentation/components/tm-icon';
import '@treasury/presentation/components/tm-list';
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { ResearchedTransactionAccountVm } from '../data/researched-transaction-account-view-model';
import { ResearchedTransactionVm } from '../data/researched-transaction-view-model';
import './account-research-transactions-account-detail-sheet';

export const tagName = 'account-research-transactions-accounts-table';
@customElement(tagName)
export class AccountResearchTransactionsAccountsTable extends TmBaseComponent {
    @property({ type: Array })
    public accounts: ResearchedTransactionAccountVm[] = [];

    @property({ type: Boolean })
    public loading = true;

    @property()
    public transactionDateRange = '';

    @state()
    private accountTransactionsOpen = false;

    @state()
    private selectedAccountTransactions: ResearchedTransactionVm[] = [];

    protected render() {
        return html`
            <account-research-transactions-account-detail-sheet
                .open=${this.accountTransactionsOpen}
                .transactions=${this.selectedAccountTransactions}
                .transactionDateRange=${this.transactionDateRange}
                @close=${() => {
                    this.accountTransactionsOpen = false;
                }}
                @open=${() => {
                    this.accountTransactionsOpen = true;
                }}
            ></account-research-transactions-account-detail-sheet>
            <tm-list
                .items=${this.accounts}
                .disableStickyHeaders=${true}
                .loading=${this.loading}
                .itemsDescriptor=${'accounts'}
                .searchFields=${['accountName', 'transactionCount']}
                .filterButton=${true}
                .columns=${[
                    {
                        renderer: (account: ResearchedTransactionAccountVm) =>
                            html`<div class="flex w-full py-2">
                                <div class="flex-grow">
                                    <div class="font-medium">${account.accountName}</div>
                                </div>
                                <div class="flex items-center text-right">
                                    <tm-badge class="mr-1">${account.transactionCount}</tm-badge>
                                    <tm-icon
                                        .icon=${chevronForwardIcon}
                                        .width=${'18px'}
                                        .height=${'18px'}
                                        color="var(--tertiary-text-color)"
                                    ></tm-icon>
                                </div>
                            </div>`,
                    },
                ]}
                @select-list-item=${(e: CustomEvent) => {
                    this.selectedAccountTransactions = e.detail.transactions;
                    this.accountTransactionsOpen = true;
                }}
                @open-list-filter=${() => {
                    this.dispatchEvent(new CustomEvent('filter-transactions'));
                }}
            ></tm-list>
        `;
    }

    public static get styles() {
        return [
            css`
                :host {
                    --grid-height: calc(100vh - 200px);
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: AccountResearchTransactionsAccountsTable;
    }
}
